import { Component, Input, OnInit } from '@angular/core';

import { Layer, PointCloudLayer, Project, RasterLayer, VectorLayer } from '@mirage-projects/cw-models';

@Component({
    selector: 'cw-horizontal-layer',
    templateUrl: './horizontal-layer.component.html',
    styleUrls: ['./horizontal-layer.component.scss'],
    standalone: false,
})
export class HorizontalLayerComponent implements OnInit {
    /*
     *Inputs to have all the data information from rasterLayer options, pointCloud layer and layerData
     */
    @Input() layerData: Layer | undefined;
    /**
     * input to have all the project optionData
     */
    @Input() projectData: Project | undefined;

    rasterOptions!: RasterLayer;
    pointCloudOptions!: PointCloudLayer;
    vectorLayerOptions!: VectorLayer;

    ngOnInit(): void {
        this.rasterOptions = this.layerData as RasterLayer;
        this.pointCloudOptions = this.layerData as PointCloudLayer;
        this.vectorLayerOptions = this.layerData as VectorLayer;
    }

    get isRaster(): boolean {
        return this.layerData?.layerType === 'RasterLayer';
    }

    get isPointCloud(): boolean {
        return this.layerData?.layerType === 'PointCloud';
    }

    get isVectorLayer(): boolean {
        return this.layerData?.layerType === 'VectorLayer';
    }
}
